<script>
import { fromArray } from '@/util/object';
/**
 * 排序
 */
const sortFields = (config, scopedSlots) => {
    let fields = fromArray(JSON.parse(config.content), i => i.name || i.dataIndex),
        slots = hideFields(scopedSlots, fields);
    slots.sort((x, y) => x.index - y.index);
    return slots.map(i => i.content);
}
/**
 * 过滤hidden项
 */
const hideFields = (scopedSlots, fields) => {
    let slots = [];
    Object.keys(scopedSlots).forEach((name, index) => {
        let field = fields ? fields[name] : null, items = scopedSlots[name](), item = items[0], visible;
        if (item.data && item.data.attrs && item.data.attrs.hidden) { 
            // 默认隐藏的字段，只有设置hidden: false，才会显示
            if (field && field.hidden === false) {
                visible = true;
                item.data.attrs.hidden = false;
            }
        } else {
            // 默认显示的字段，如果设置了hidden: true，才不会显示
            if (!field || !field.hidden) {
                visible = true;
            }
        }
        if (visible) {
            //自定义字段
            if (field && field.type && /_text/.test(name)) {
                item.data.attrs.fieldType = field.type;
            }
            slots.push({
                content: item,
                // 如果viewConfig未配置该字段，该字段按原顺序展示
                index: field ? field.index : index
            });
        }
    });
    return slots;
}

export default {
    name: 'CustomLayout',
    functional: true,
    inheritAttrs: false,
    props: {
        viewConfig: { type: Array, default: void 0 },
        tag: { type: String, default: 'div' },
        position: { type: String, default: 'main' }
    },
    render(h, { data, props: { viewConfig, tag, position }, scopedSlots }) {
        let config = viewConfig ? viewConfig.find(i => i.position == position) : null,
            content = [];
        if (config) {
            content = sortFields(config, scopedSlots);
        } else {
            // 没有配置的情况，按原顺序展示
            content = hideFields(scopedSlots).map(i => i.content);
        }
        // 未加slot的字段，不参与排序，直接展示
        if (scopedSlots.default) {
            content.push(...scopedSlots.default());
        }
        return h(tag, data, content);
    }
}
</script>